import mixpanelBrowser from "mixpanel-browser";

mixpanelBrowser.init(import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN, {
    debug: import.meta.env.VITE_VERCEL_ENV !== "production",
    // it doesn't work with remix, we need to do it through useTrackPageView hook below
    track_pageview: true, // false,
    persistence: "localStorage",
    loaded: function (mp) {
        document.cookie = `distinct_id=${mp.get_distinct_id()}`;
    },
    ignore_dnt: import.meta.env.VITE_VERCEL_ENV !== "production" ? true : false,
    autotrack: true,
});

declare global {
    interface Window {
        dataLayer: any[];
    }
}

/** GTM / Tag Manager only (no Mixpanel) — avoids double-counting when the server already tracked the same action. */
export function pushDataLayerEvent(event: string, payload: Record<string, unknown>) {
    if (typeof window !== "undefined" && window.dataLayer) {
        window.dataLayer.push({ event, ...payload });
    }
}

export const analytics = {
    track(name: string, properties: any) {
        mixpanelBrowser.track(name, properties);
        if (window.dataLayer) {
            window.dataLayer.push({ event: name, ...properties });
        }
    },
    trackLinks(selector: string, name: string, properties: any) {
        mixpanelBrowser.track_links(selector, name, properties);
        if (window.dataLayer) {
            document.querySelectorAll(selector).forEach((node) => {
                node.addEventListener("click", () => {
                    window.dataLayer.push({ event: name, ...properties });
                });
            });
        }
    },
    trackPageView() {
        mixpanelBrowser.track_pageview();
        if (window.dataLayer) {
            window.dataLayer.push({
                event: "page_view",
                pagePath: window.location.pathname,
                pageTitle: document.title,
            });
        }
    },
};
